// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MNxz","title":"styles_title__2z3cg"};